export const GENOMIC_LABELS_MAP = {
  geneId: "Gene ID",
  assemblyId: "Assembly",
  chromosome: "Chromosome",
  start: "Start Position",
  end: "End Position",
  variationType: "Variant Type",
  alternateBases: "Alternate Bases",
  referenceBases: "Reference Bases",
  referenceName: "Chromosome",
  refBases: "Reference Bases",
  altBases: "Alternate Bases",
  aminoacidChange: "Amino Acid Change",
  refAa: "Reference AA",
  altAa: "Alternate AA",
  aaPosition: "AA Position",
  minVariantLength: "Min Variant Length",
  maxVariantLength: "Max Variant Length",
  genomicHGVSshortForm: "HGVS ID",
  genomicAlleleShortForm: "HGVS ID",
  startMin: "Start Min",
  startMax: "Start Max",
  endMin: "End Min",
  endMax: "End Max",
};
